import { observable, action } from 'mobx'

class LoadingAnimationStore {
  @observable loading = true

  @action.bound finished() {
    this.loading = false
  }
}

export default new LoadingAnimationStore()



// WEBPACK FOOTER //
// ./src/stores/loadingAnimationStore.js